import { Component, computed, inject, input, output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { DEFAULT_TIME_FORMAT } from '@app/shared/configs/date-format.config';
import { IntlDurationPipe } from '@app/shared/pipes/intl-duration.pipe';
import { ProffeoDatePipe } from '@app/shared/pipes/proffeo-date.pipe';
import { TimeReportsActionsService } from '@app/shared/services/actions/time-reports-actions.service';
import { AuthService } from '@app/shared/services/auth.service';
import { TimeReport } from '@app/shared/types/models/reports/time-report';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'task-time-report-card',
  imports: [MatIconModule, IntlDurationPipe, ProffeoDatePipe, MatMenu, MatMenuItem, TranslatePipe, MatMenuTrigger],
  templateUrl: './task-time-report-card.component.html'
})
export class TaskTimeReportCardComponent {
  private readonly authService = inject(AuthService);
  private readonly timeReportsActionsService = inject(TimeReportsActionsService);

  protected readonly defaultTimeFormat = DEFAULT_TIME_FORMAT;

  protected readonly canManageReport = computed((): boolean => {
    const currentUser = this.authService.currentUser();
    if (!currentUser) {
      return false;
    }

    return (
      currentUser.id === this.report().user()?.id || this.timeReportsActionsService.isTimeReportAdmin(currentUser.email)
    );
  });
  protected editReport = output<TimeReport>();
  protected deleteReport = output<TimeReport>();

  public readonly report = input.required<TimeReport>();

  public onEditTimeReportCardClick(report: TimeReport): void {
    this.editReport.emit(report);
  }

  public onDeleteTimeReportCardClick(report: TimeReport): void {
    this.deleteReport.emit(report);
  }
}
